module.exports = __webpack_public_path__ + "media/Blob 4 Joins.0e813937.mp3";